function textSearch(property: string | undefined, searchText: string): boolean {
  return (property ?? "").toLowerCase().includes(searchText.toLowerCase());
}

export { textSearch };
